export default __webpack_public_path__ + "static/media/VoltLogoPurple.125355f6.svg";